import { AxiosAPI } from './axios-service-creator';

export type SignInPayload = {
  username: string;
  password: string;
}

export const AuthenticationAPI = {
  signIn: (payload: SignInPayload) => AxiosAPI.post('/auth/login', payload),
}